import React from 'react'
import './styles.scss'

class PredictedAge extends React.Component {
  shareClick(service) {
    /* eslint-disable */
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: 'personalized share: ' + service
    })
    /* eslint-enable */
  }

  constructor(props) {
    super(props)
    this.shareClick = this.shareClick.bind(this)
  }

  render() {
    const appData = this.props.appData
    let predictedAge = appData.user.predictedAge
    let generationText = ''
    if (predictedAge < 24) {
      generationText = 'Vous appartenez à la «Génération Z» (jusqu’à 24 ans)'
    } else if (predictedAge < 38) {
      generationText = 'Vous appartenez à la «Génération Y» (de 25 à 38 ans)'
    } else if (predictedAge < 54) {
      generationText = 'Vous appartenez à la «Génération X» (de 39 à 55 ans)'
    } else {
      generationText = 'Vous appartenez aux «baby-boomers» (plus de 55 ans)'
    }
    let shareLink =
      window.location.protocol +
      '//' +
      window.location.host +
      window.location.pathname
    let shareText =
      'Mon âge musical est ' +
      predictedAge +
      ' ans. Trouvez ' +
      'le vôtre: ' +
      shareLink +
      ' #monagemusical'
    let twitterShareText = shareText
    return (
      <>
        <div className='ui text container center aligned'>
          <svg
            width='439'
            height='258'
            viewBox='0 0 439 258'
            xmlns='http://www.w3.org/2000/svg'
          >
            <g fill='none'>
              <path
                d='M435.635 258H3.365A220.854 220.854 0 0 1 0 219.5C0 98.273 98.273 0 219.5 0S439 98.273 439 219.5c0 13.135-1.154 26-3.365 38.5z'
                fill='#2D2D2D'
              />
              <g>
                <path
                  d='M224.6 63c-6.836 0-13.366 1.462-19.434 4.308-15.902 7.461-26.272 23.615-26.272 41.307v6.847l-8.758 16.769c-1.46 2.538-1.46 5.077-.307 7.154 1.306 1.923 3.534 3 6.376 3h2.535v14.692c0 5.923 4.763 10.846 10.831 10.846h.154L202.477 166l25.81-4.462a10.794 10.794 0 0 0 9.373-12v-22.615c8.91-.77 16.055-8.308 16.055-17.538 0-9.693-7.99-17.693-17.669-17.693s-17.668 8-17.668 17.693c0 9.23 6.99 16.769 16.055 17.538v22.923c.461 4.154-2.381 8-6.683 8.616l-25.81 4.461-12.599 1.923c-4.148 0-7.451-3.538-7.451-7.692v-16.23c0-.924-.615-1.616-1.614-1.616h-4.148c-1.767 0-2.996-.462-3.687-1.616-.615-.923-.46-2.384.307-4l8.911-17.077c.154-.153.154-.461.154-.769v-7.308c0-16.461 9.525-31.384 24.505-38.461 5.761-2.692 11.753-4 17.975-4 23.276 0 42.404 19 42.404 42.461 0 11.77-4.917 23.308-13.674 31.231-.307.308-.46.77-.46 1.154v33.462c0 .923.614 1.615 1.612 1.615 1 0 1.614-.615 1.614-1.615v-32.847c9.064-8.615 14.211-20.538 14.211-33C270 83.385 249.643 63 224.6 63zm-2.842 46.23c0-8 6.53-14.538 14.519-14.538s14.518 6.539 14.518 14.539-6.53 14.538-14.518 14.538c-7.99 0-14.519-6.538-14.519-14.538z'
                  fill='#FFF'
                />
                <path
                  d='M236 97c-6.573 0-12 5.35-12 12 0 6.573 5.35 12 12 12 6.573 0 12-5.35 12-12s-5.35-12-12-12zm5.503 17.274c-.23.382-.688.458-.993.23-2.828-1.682-6.344-2.14-10.548-1.147-.382.076-.765-.153-.917-.535-.077-.383.152-.765.535-.918 4.586-1.07 8.484-.611 11.617 1.3.383.23.535.688.306 1.07zm1.452-3.287c-.305.459-.84.612-1.299.306-3.21-1.987-8.102-2.522-11.924-1.376-.458.153-.993-.153-1.146-.611-.153-.459.153-.994.611-1.147 4.357-1.3 9.784-.688 13.453 1.605.458.23.611.841.305 1.223zm.153-3.363c-3.821-2.293-10.242-2.522-13.91-1.376-.612.153-1.223-.152-1.376-.764-.153-.611.153-1.223.764-1.376 4.204-1.3 11.236-1.07 15.669 1.605.535.306.688.994.382 1.529-.306.535-.994.688-1.529.382z'
                  fill='#54AF71'
                />
              </g>
            </g>
            <text
              x={439 / 2}
              y={258 - 30}
              transform='translate(10, 0)'
              className='predictedage-text'
              style={{ textAnchor: 'middle' }}
            >
              {predictedAge} ans
            </text>
          </svg>
          <div className='generation-info'>{generationText}</div>
        </div>
        <div className='ui text container sharing-container'>
          <div className='ui middle aligned sixteen wide mobile column'>
            <p>Partagez votre âge musical</p>
            <div className='sharing-buttons ui middle aligned'>
              <a
                href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(
                  twitterShareText
                )}`}
                onClick={() => this.shareClick('twitter')}
                target='_blank'
                className='ui button'
              >
                <i className='twitter icon' /> Twitter
              </a>
              <a
                href={`whatsapp://send?text=${encodeURIComponent(shareText)}`}
                onClick={() => this.shareClick('whatsapp')}
                className='ui button'
              >
                <i className='whatsapp icon' /> Whatsapp
              </a>
              <a
                href={`mailto:?body=${encodeURIComponent(shareText)}`}
                onClick={() => this.shareClick('email')}
                className='ui button'
              >
                <i className='envelope outline icon' /> E-Mail
              </a>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default PredictedAge
